import { Box, Grid2, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import React from "react";
import Wallet from "../icons/WalletIcon";

export default function Header() {
  const navigate = useNavigate();
  return (
    <Grid2 container sx={{ justifyContent: "space-between" }}>
      <Grid2
        container
        alignItems="center"
        spacing={1}
        sx={{ cursor: "pointer" }}
        onClick={() => {
          navigate("/");
        }}
      >
        <Box
          sx={{
            borderRadius: "50%",
            backgroundColor: "#0F0F12",
            padding: "5px",
          }}
        >
          <img
            src="/images/image/logo.png"
            style={{ width: "31px", height: "24px", objectFit: "contain" }}
            alt="logo"
          />
        </Box>
        <Typography variant="body2">MERCHANT BRAND</Typography>
      </Grid2>
      <Grid2
        container
        alignItems="center"
        spacing={1}
        sx={{ cursor: "pointer" }}
        onClick={() => {
          navigate("/wallet");
        }}
      >
        <Wallet />
        <Typography variant="body2">My Wallet</Typography>
      </Grid2>
    </Grid2>
  );
}
